import { Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface Props {
  name: string;
  label: string;
  disabled?: boolean;
  helperText?: React.ReactNode; // optional helper text
}

const VNCheckBox = ({ name, label, disabled, helperText }: Props) => {
  const { control } = useFormContext();

  return (
    <div className="vn-checkbox">
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  disabled={disabled}
                />
              }
              label={label}
            />
            {helperText && (
              <FormHelperText style={{ marginLeft: 32 }} component="div">
                {helperText}
              </FormHelperText>
            )}
          </>
        )}
      />
    </div>
  );
};

export default VNCheckBox;
